
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#EAEDFF"}}),_c('path',{attrs:{"d":"M23.338 10h-5.834a5 5 0 000 10h5.834v1.667c0 .46-.373.833-.834.833h-15a.833.833 0 01-.833-.833V8.333c0-.46.373-.833.833-.833h15c.46 0 .834.373.834.833V10zm-5.834 1.667h6.667v6.666h-6.667a3.333 3.333 0 110-6.666zm0 2.5v1.666h2.5v-1.666h-2.5z","fill":"#2B4BFF"}})])
          )
        }
      }
    